import { css } from '@emotion/core'
import { colors, measures, zIndexes } from 'styles/variables'
import { px } from 'utils/styles'

const { unit } = measures

export const header = css`
  display: flex;
  justify-content: flex-end;
`

export const dialogStyles = {
  content: {
    position: 'relative',
    width: px(42 * unit),
    left: 'auto',
    right: 'auto',
    top: 'none',
    bottom: 'none',
    textAlign: 'center',
    backgroundColor: colors.grays.gray6,
  },

  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.black60,
    zIndex: zIndexes.overlay,
  },
}
